export var UserEndpoints;
(function (UserEndpoints) {
    UserEndpoints["USER"] = "/user";
    UserEndpoints["CLIENT_INFO"] = "/client-info";
    UserEndpoints["PERSISTENT_MENU"] = "/persistent-menu";
    UserEndpoints["TYPING"] = "/typing";
    UserEndpoints["HEADER_INFO"] = "/header-info";
})(UserEndpoints || (UserEndpoints = {}));
